import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            分类浏览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            八大资源分类，总有一类适合你。点击分类开始探索
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-50 text-primary-600 rounded-xl mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                {cat.description}
              </p>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-file-text-line"></i>
                <span>{cat.articleCount.toLocaleString()} 条资源</span>
                <i className="ri-arrow-right-line ml-auto group-hover:text-primary-500 transition-colors"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}